export default __webpack_public_path__ + "static/media/logow.f3d46714.png";